import { Language } from 'store/slices/language-slice';

interface LegalNavigationMessages {
  legalNavigationMessages: {
    header: string;
    ourTerms: string;
    privacyPolicy: string;
    disclaimers: string;
    riskDisclosure: string;
  };
}

type Message = {
  [key in Language]: LegalNavigationMessages;
};

const messages: Message = {
  en: {
    legalNavigationMessages: {
      header: 'Legal',
      ourTerms: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      disclaimers: 'Disclaimers',
      riskDisclosure: 'Risk Disclosure',
    },
  },
};

export default messages;
